import Element from 'element-ui';
import '@/styles/element-variables.scss';
import uploadFromComponent from './index.vue';
import Vue from 'vue';
import Cookies from 'js-cookie';
Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
});
var uploadFrom = {};
uploadFrom.install = function (Vue, options) {
  var ToastConstructor = Vue.extend(uploadFromComponent);
  // 生成一个该子类的实例
  var instance = new ToastConstructor();
  instance.$mount(document.createElement('div'));
  // 全局挂载实例只作为 $modalUpload 的弹窗容器使用，不显示左下角触发按钮。
  instance.isShow = false;
  document.body.appendChild(instance.$el);
  Vue.prototype.$modalUpload = function (callback, isMore, modelName, boolean) {
    var uploadOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    // 确保实例可见并重置
    instance.visible = true;
    instance.maxSizeKB = uploadOptions.maxSizeKB || 0;
    instance.maxSizeErrorMsg = uploadOptions.maxSizeErrorMsg || '';
    instance.acceptExts = uploadOptions.acceptExts || [];
    instance.acceptErrorMsg = uploadOptions.acceptErrorMsg || '';
    instance.bothErrorMsg = uploadOptions.bothErrorMsg || '';

    // 设置回调函数，确保回调函数能正确处理图片数据
    instance.callback = function (images) {
      console.log('Modal upload callback with images:', images);
      if (typeof callback === 'function') {
        // 确保图片数据有效
        if (images && Array.isArray(images)) {
          // 添加时间戳避免缓存问题
          var processedImages = images.map(function (img) {
            if (img && img.sattDir) {
              // 不重复添加时间戳
              if (!img.sattDir.includes('t=')) {
                var timestamp = new Date().getTime();
                var separator = img.sattDir.includes('?') ? '&' : '?';
                img.sattDir = "".concat(img.sattDir).concat(separator, "t=").concat(timestamp);
              }
            }
            return img;
          });
          callback(processedImages);
        } else {
          console.warn('Invalid image data returned from upload component');
          callback([]);
        }
      }
    };

    // 设置其他参数
    instance.isMore = isMore;
    instance.modelName = modelName;
    instance.booleanVal = boolean;
  };
};
export default uploadFrom;